/* Bagifi header enhancements */
(function () {
  /* Sticky header only while the cart has items */
  function applySticky() {
    var s = document.getElementById('shopify-section-header');
    if (!s) return;
    var hasItems = !!s.querySelector('.cart-count-bubble');
    s.classList.toggle('header--cart-sticky', hasItems);
  }

  /* When a variant is picked and the header is sticky, make sure the theme
     scroll never leaves the product image tucked under the header. */
  function fixVariantCover() {
    var h = document.getElementById('shopify-section-header');
    if (!h || !h.classList.contains('header--cart-sticky')) return;
    var m = document.querySelector('media-gallery,.product__media-wrapper,.product__media-list');
    if (!m) return;
    var hh = h.getBoundingClientRect().height;
    var r = m.getBoundingClientRect();
    if (r.top < hh && r.bottom > hh) {
      var d = Math.max(0, r.top + window.pageYOffset - hh - 8);
      window.scrollTo(0, d);
    }
  }

  function onVariantChange(e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('input[name=Color],input[name=Size],variant-radios input,variant-selects input,variant-selects select,.product-form__input input,.product-form__input select')) {
      setTimeout(fixVariantCover, 300);
      setTimeout(fixVariantCover, 650);
    }
  }

  function init() {
    applySticky();
    var b = document.getElementById('cart-icon-bubble');
    if (b) {
      new MutationObserver(applySticky).observe(b, { childList: true, subtree: true });
    }
    document.addEventListener('cart:refresh', applySticky);
    document.addEventListener('change', onVariantChange, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
